module.exports = __webpack_public_path__ + "static/img/profile.325b7c21.png";